import { createContext } from 'react';
import {
	TFileId,
	IItemForGetShortInfo,
	TLanguageIDs,
	IMenuTranslation,
	IDefaultLanguage,
	ICreateSubcategoryV2,
} from 'types';

export type TTypeOfModalWindow =
	| null
	| 'toConfirmFieldsClearing'
	| 'toConfirmSubmit'
	| 'success'
	| 'error'
	| 'defaultTranslationIsEmpty';

export interface ICreateSubcategoryState {
	fileId: TFileId;
	fetchedCustomers: IItemForGetShortInfo[];
	IDSelectedCustomer: Nullable<string>;
	fetchedRestaurants: IItemForGetShortInfo[];
	IDsSelectedRestaurant: string[];
	fetchedCategories: IItemForGetShortInfo[];
	IDSelectedCategory: Nullable<string>;
	nameOfSubcategory: string;
	hasSchedulePriority: boolean;
	activationSchedule: string;
	deactivationSchedule: string;
	defaultCustomerLanguage: Nullable<IDefaultLanguage>;
	selectedTranslationTab: Nullable<TLanguageIDs>;
	translations: IMenuTranslation[];
	dataForSubmit: Nullable<ICreateSubcategoryV2>;
	typeOfModalWindow: TTypeOfModalWindow;
}

export const createSubcategoryInitialState: ICreateSubcategoryState = {
	fileId: null,
	fetchedCustomers: [],
	IDSelectedCustomer: null,
	fetchedRestaurants: [],
	IDsSelectedRestaurant: [],
	fetchedCategories: [],
	IDSelectedCategory: null,
	nameOfSubcategory: '',
	hasSchedulePriority: false,
	activationSchedule: '',
	deactivationSchedule: '',
	defaultCustomerLanguage: null,
	selectedTranslationTab: null,
	translations: [],
	dataForSubmit: null,
	typeOfModalWindow: null,
};

export interface ICreateSubcategoryContext extends ICreateSubcategoryState {
	setFileId(value: TFileId): void;
	setFetchedCustomers(value: IItemForGetShortInfo[]): void;
	setIDCustomer(value: Nullable<string>): void;
	setFetchedRestaurants(value: IItemForGetShortInfo[]): void;
	setIDsRestaurant(value: string[]): void;
	setFetchedCategories(value: IItemForGetShortInfo[]): void;
	setIDCategory(value: Nullable<string>): void;
	changeNameOfSubcategory(value: string): void;
	toggleHasSchedulePriority(): void;
	changeActivationSchedule(value: string): void;
	changeDeactivationSchedule(value: string): void;
	setFetchedTranslations(value: TLanguageIDs[], defaultCustomerLanguage: Nullable<IDefaultLanguage>): void;
	setTranslationTab(value: Nullable<TLanguageIDs>): void;
	changeNameTranslation(languageId: TLanguageIDs, value: string): void;
	setDataForSubmit(data: ICreateSubcategoryV2): void;
	changeTypeOfModalWindow(value: TTypeOfModalWindow): void;
	resetFields(): void;
}

export const CreateSubcategoryContext = createContext<ICreateSubcategoryContext>({
	setFileId: () => undefined,
	setFetchedCustomers: () => undefined,
	setIDCustomer: () => undefined,
	setFetchedRestaurants: () => undefined,
	setIDsRestaurant: () => undefined,
	setFetchedCategories: () => undefined,
	setIDCategory: () => undefined,
	changeNameOfSubcategory: () => undefined,
	toggleHasSchedulePriority: () => undefined,
	changeActivationSchedule: () => undefined,
	changeDeactivationSchedule: () => undefined,
	setFetchedTranslations: () => undefined,
	setTranslationTab: () => undefined,
	changeNameTranslation: () => undefined,
	setDataForSubmit: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	resetFields: () => undefined,
	...createSubcategoryInitialState,
});
